/**
 * Word lists used to classify the "Digitales Fahrtenbuch" custom property that the vehicle data
 * check script writes into the device master data. Comparison is done on the normalized value
 * (lowercase, collapsed whitespace, trimmed).
 */
export const VEHICLE_CHECK_PROPERTY_NAMES = ["Digitales Fahrtenbuch", "Fahrtenbuch"] as const;

export const VEHICLE_CHECK_LAST_CHECK_PROPERTY_NAME = "Letzte Prüfung";

export const VEHICLE_CHECK_OK_WORDS = [
  "okay",
  "ok",
  "in ordnung",
  "gut",
  "bestanden",
  "erfüllt",
  "aktiv",
] as const;

export const VEHICLE_CHECK_WARN_PREFIXES = [
  "akzeptabel",
  "eingeschränkt",
  "teilweise",
  "warnung",
] as const;

export const VEHICLE_CHECK_ALERT_WORDS = [
  "prüfen",
  "pruefen",
  "fehler",
  "kritisch",
  "nicht ok",
  "fehlt",
  "inaktiv",
  "nicht in ordnung",
] as const;
